// import { get } from "lodash";

export default {
  getRegistration: (state) => state.registration.registration,
  selectSeatedSellerRegistrationInfo: (state) => state.registration.seatedSellerRegistrationInfo,
};
